import type { AgentRecord } from "@/types"

import { SimulatorType } from "@/types/api/SimulatorType"
import type { FormData } from "@/types/FormData"
import { getApplyLinkedMetricsToConversationUploads } from "@/utils/agentMetadata"

export const EMPTY_AGENT_FORM_DATA: FormData = {
  display_name: "",
  model_type: SimulatorType.VOICE,
  phone_number: "",
  endpoint: "",
  metadata: {},
  attributes: {},
  prompt: "",
  workflows: null,
  metric_ids: [],
  apply_linked_metrics_to_conversation_uploads: false,
}

const getEditableMetadata = (agent: AgentRecord): Record<string, unknown> => {
  const metadata = { ...(agent.metadata || {}) }
  if ((agent.model_type as SimulatorType) === SimulatorType.LIVEKIT) {
    delete metadata.livekit_agent_metadata
  }
  return metadata
}

export const toAgentFormData = (
  agent: AgentRecord | null | undefined,
): FormData | null => {
  if (!agent) {
    return null
  }

  const metadata = getEditableMetadata(agent)

  return {
    display_name: agent.display_name || "",
    model_type: agent.model_type || SimulatorType.VOICE,
    phone_number: agent.phone_number || "",
    endpoint: agent.endpoint || "",
    metadata,
    attributes: agent.attributes || {},
    prompt: agent.prompt || "",
    workflows: agent.workflows || {},
    metric_ids: agent.metric_ids || [],
    apply_linked_metrics_to_conversation_uploads:
      getApplyLinkedMetricsToConversationUploads(metadata),
    language: agent.language || "",
  }
}
